import React, { Component } from 'react';
import { Rng } from './rand.mjs';
import { iconurl } from './names.mjs';

import './PortraitsView.css';
import { rolesBykey } from './data/google/processor/data_char2roles.mjs';
import { L } from './localization.mjs';
import { TierBadge2 } from './Badges.js';
import portraitResources from './data/portrait/PortraitResourceList.json' assert { type: 'json' };
import defaultPresetData from './data/portrait/PortraitDefaultPreset.json' assert {type: 'jason'};

export const PORTRAIT_PRESET_ZOOM = 'translate(0,+10%) scale(1.5) rotate(0deg)';

const DEFAULT_PRESET = defaultPresetData['preset'];

class PortraitLayer {
  constructor(role) {
    this.layers = portraitResources[role];
    this.layerSize = {};
    let totalSize = 0;
    for (const key in this.layers) {
      const size = this.layers[key].length;
      this.layerSize[key] = size;
      totalSize += size;
    }
    this.totalSize = totalSize - 1;
    this.table = new Array(totalSize);
  }

  hash(key) {
    const prime = 31;
    return (key * prime) % this.table.length;
  }

  getLayer(key) {
    let index = this.hash(key);
    const originalIndex = index;
    while (this.table[index] && this.table[index] !== key) {
      index = (index + 1) % this.table.length;
      if (index === originalIndex) {
        throw new Error('Hash table is full');
      }
    }
    this.table[index] = key;
    return { index: index, layer: this.makeLayer(index) };
  }

  hasKey(key) {
    return this.table.includes(key);
  }

  makeLayer(index) {
    let curIndex = index;
    const layer = {};
    for (const layerType in this.layers) {
      const id = curIndex % this.layerSize[layerType];
      layer[layerType] = this.layers[layerType][id];
      curIndex = curIndex | this.layerSize[layerType]
      curIndex -= this.layerSize[layerType];
    }
    return layer;
  }
}

class RolePortraitLayers {
  constructor() {
    this.pointmanLayer = new PortraitLayer('pointman');
    this.vanguardLayer = new PortraitLayer('vanguard');
    this.medicLayer = new PortraitLayer('medic');
    this.breacherLayer = new PortraitLayer('breacher');
    this.sharpshooterLayer = new PortraitLayer('sharpshooter');
  }

  getLayer(idx, role) {
    if (this.pointmanLayer.hasKey(idx)) {
      return this.pointmanLayer.getLayer(idx)['layer'];
    }
    if (this.vanguardLayer.hasKey(idx)) {
      return this.vanguardLayer.getLayer(idx)['layer'];
    }
    if (this.medicLayer.hasKey(idx)) {
      return this.medicLayer.getLayer(idx)['layer'];
    }
    if (this.breacherLayer.hasKey(idx)) {
      return this.breacherLayer.getLayer(idx)['layer'];
    }
    if (this.sharpshooterLayer.hasKey(idx)) {
      return this.sharpshooterLayer.getLayer(idx)['layer'];
    }

    switch (role) {
      case 'pointman':
        return this.pointmanLayer.getLayer(idx)['layer'];
      case 'vanguard':
        return this.vanguardLayer.getLayer(idx)['layer'];
      case 'medic':
        return this.medicLayer.getLayer(idx)['layer'];
      case 'breacher':
        return this.breacherLayer.getLayer(idx)['layer'];
      case 'sharpshooter':
        return this.sharpshooterLayer.getLayer(idx)['layer'];
    }
    return {};
  }
}

const rolePortraitLayers = new RolePortraitLayers();

export function generatePortrait(role, idx) {
  return rolePortraitLayers.getLayer(idx, role);
}

export function PortraitWrapper(props) {
  const { agent, className, onClick, preset, noframe, isDead, noRole } = props;
  const { name, role } = agent;
  const url = iconurl(name);
  let body = null;
  if (url) {
    body = <img alt={name} src={url} className={className} onDragStart={(e) => e.preventDefault()} />;
  }
  if (!isNaN(url)) {
    body = <PortraitView role={role} idx={url} preset={preset} className={className} noframe={noframe} />;
  }
  let label = null;
  if (role && !noRole) {
    const cls = `flex-agents-portrait-label flex-agents-portrait-label-${role}`;
    label = <div className={cls}>{rolesBykey(role)?.name ?? role}</div>;
  }
  let attrs = {
    className: (className ? className + ' flex-agents-portrait' : 'flex-agents-portrait') + (onClick ? ' clickable' : ''),
    onClick,
    'data-clickable': onClick ? 'true' : undefined,
  };
  let deathBanner = null;
  if (isDead) {
    deathBanner = <div className="flex-agents-portrait-dead">{L('loc_ui_string_ingame_agentcard_kia')}</div>;
  }
  return <div {...attrs}>
    {body}
    {label}
    {deathBanner}
  </div>;
}

const roleIconTags = {
  'pointman': <svg className="portrait-wrapper2-tag" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
    <path opacity="0.5" d="M0.0859375 0.500031H48.4564L0.0859375 48.8184V0.500031Z" fill="black" />
    <path opacity="0.6" d="M0.0859375 0.500031H48.4564L0.0859375 48.8184V0.500031Z" fill="url(#paint0_linear_1255_45555)" />
    <path d="M17.6559 14.5C17.6559 16.4722 16.0571 18.071 14.085 18.071C12.1128 18.071 10.514 16.4722 10.514 14.5C10.514 12.5279 12.1128 10.9291 14.085 10.9291C16.0571 10.9291 17.6559 12.5279 17.6559 14.5Z" fill="#359CD6" />
    <path fillRule="evenodd" clipRule="evenodd" d="M14.085 24.0225C19.3441 24.0225 23.6074 19.7592 23.6074 14.5C23.6074 9.24093 19.3441 4.97757 14.085 4.97757C8.82586 4.97757 4.5625 9.24093 4.5625 14.5C4.5625 19.7592 8.82586 24.0225 14.085 24.0225ZM14.085 21.0382C17.6959 21.0382 20.6232 18.111 20.6232 14.5C20.6232 10.8891 17.6959 7.96184 14.085 7.96184C10.4741 7.96184 7.5468 10.8891 7.5468 14.5C7.5468 18.111 10.4741 21.0382 14.085 21.0382Z" fill="#359CD6" />
    <path fillRule="evenodd" clipRule="evenodd" d="M14.085 23.0225C18.7918 23.0225 22.6074 19.2069 22.6074 14.5C22.6074 9.79321 18.7918 5.97757 14.085 5.97757C9.37814 5.97757 5.5625 9.79321 5.5625 14.5C5.5625 19.2069 9.37814 23.0225 14.085 23.0225ZM14.085 17.071C15.5049 17.071 16.6559 15.9199 16.6559 14.5C16.6559 13.0802 15.5049 11.9291 14.085 11.9291C12.6651 11.9291 11.514 13.0802 11.514 14.5C11.514 15.9199 12.6651 17.071 14.085 17.071ZM21.6232 14.5C21.6232 18.6633 18.2482 22.0382 14.085 22.0382C9.92177 22.0382 6.5468 18.6633 6.5468 14.5C6.5468 10.3368 9.92177 6.96184 14.085 6.96184C18.2482 6.96184 21.6232 10.3368 21.6232 14.5ZM23.6074 14.5C23.6074 19.7592 19.3441 24.0225 14.085 24.0225C8.82586 24.0225 4.5625 19.7592 4.5625 14.5C4.5625 9.24093 8.82586 4.97757 14.085 4.97757C19.3441 4.97757 23.6074 9.24093 23.6074 14.5ZM20.6232 14.5C20.6232 18.111 17.6959 21.0382 14.085 21.0382C10.4741 21.0382 7.5468 18.111 7.5468 14.5C7.5468 10.8891 10.4741 7.96184 14.085 7.96184C17.6959 7.96184 20.6232 10.8891 20.6232 14.5ZM14.085 18.071C16.0571 18.071 17.6559 16.4722 17.6559 14.5C17.6559 12.5279 16.0571 10.9291 14.085 10.9291C12.1128 10.9291 10.514 12.5279 10.514 14.5C10.514 16.4722 12.1128 18.071 14.085 18.071Z" fill="#2088C2" />
    <defs>
      <linearGradient id="paint0_linear_1255_45555" x1="-0.433294" y1="1.5395" x2="23.9928" y2="24.3842" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00409F" />
        <stop offset="1" stopColor="#00409F" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>,
  'vanguard': <svg className="portrait-wrapper2-tag" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
    <path opacity="0.5" d="M0.0859375 0.500031H48.4564L0.0859375 48.8184V0.500031Z" fill="black" />
    <path opacity="0.6" d="M0.0859375 0.500031H48.4564L0.0859375 48.8184V0.500031Z" fill="url(#paint0_linear_1255_45553)" />
    <path d="M6.56445 6.75494C13.0806 5.07065 16.4781 5.09285 22.5645 6.75494V18.4706L14.5645 25.5L6.56445 18.4706V6.75494Z" fill="#FAAF3E" />
    <path fillRule="evenodd" clipRule="evenodd" d="M8.06445 7.92651V17.7918L14.5645 23.5032L21.0645 17.7918V7.91144C18.6232 7.29658 16.6779 7.00228 14.7239 7.00004C12.751 6.99779 10.7043 7.29318 8.06445 7.92651ZM22.5645 6.75494C16.4781 5.09285 13.0806 5.07065 6.56445 6.75494V18.4706L14.5645 25.5L22.5645 18.4706V6.75494Z" fill="#C1790C" />
    <defs>
      <linearGradient id="paint0_linear_1255_45553" x1="-0.433294" y1="1.5395" x2="23.9928" y2="24.3842" gradientUnits="userSpaceOnUse">
        <stop stopColor="#975100" />
        <stop offset="1" stopColor="#975100" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>,
  'medic': <svg className="portrait-wrapper2-tag" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
    <path opacity="0.5" d="M0.0859375 0.5H48.4564L0.0859375 48.8184V0.5Z" fill="black" />
    <path opacity="0.6" d="M0.0859375 0.5H48.4564L0.0859375 48.8184V0.5Z" fill="url(#paint0_linear_1255_45552)" />
    <path d="M17.2828 5.8468H12.3381V12.0277H6.15723V16.9723H12.3381V23.1532H17.2828V16.9723H23.4636V12.0277H17.2828V5.8468Z" fill="#67BA33" />
    <path fillRule="evenodd" clipRule="evenodd" d="M12.3381 12.0277H6.15723V16.9723H12.3381V23.1532H17.2828V16.9723H23.4636V12.0277H17.2828V5.8468H12.3381V12.0277ZM13.8381 7.3468V13.5277H7.65723V15.4723H13.8381V21.6532H15.7828V15.4723H21.9636V13.5277H15.7828V7.3468H13.8381Z" fill="#58A925" />
    <defs>
      <linearGradient id="paint0_linear_1255_45552" x1="-0.433294" y1="1.53947" x2="23.9928" y2="24.3842" gradientUnits="userSpaceOnUse">
        <stop stopColor="#025200" />
        <stop offset="1" stopColor="#025200" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>,
  'sharpshooter': <svg className="portrait-wrapper2-tag" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
    <path opacity="0.5" d="M0.0849609 0.5H48.4554L0.0849609 48.8184V0.5Z" fill="black" />
    <path opacity="0.6" d="M0.0849609 0.5H48.4554L0.0849609 48.8184V0.5Z" fill="url(#paint0_linear_1255_45556)" />
    <path d="M14.2223 4.78339L6.85449 17.7777L14.2223 25.2158L21.5902 17.7777L14.2223 4.78339Z" fill="#C447FF" />
    <path fillRule="evenodd" clipRule="evenodd" d="M14.2223 25.2158L21.5902 17.7777L14.2223 4.78339L6.85449 17.7777L14.2223 25.2158ZM14.2223 23.0843L19.725 17.5292L14.2223 7.82452L8.71971 17.5292L14.2223 23.0843Z" fill="#9F34D1" />
    <defs>
      <linearGradient id="paint0_linear_1255_45556" x1="-0.434271" y1="1.53947" x2="23.9918" y2="24.3842" gradientUnits="userSpaceOnUse">
        <stop stopColor="#8800C9" />
        <stop offset="1" stopColor="#8800C9" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>,
  'breacher': <svg className="portrait-wrapper2-tag" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50" fill="none">
    <path opacity="0.5" d="M0.0859375 0.500031H48.4564L0.0859375 48.8184V0.500031Z" fill="black" />
    <path opacity="0.6" d="M0.0859375 0.500031H48.4564L0.0859375 48.8184V0.500031Z" fill="url(#paint0_linear_1255_45554)" />
    <path fillRule="evenodd" clipRule="evenodd" d="M22.3477 5.59256L26.8413 9.90062L23.4329 13.4557L21.6355 11.7325L18.8342 14.6544C20.3463 17.2302 20.0377 20.5951 17.8685 22.8577C15.2513 25.5875 10.9167 25.6789 8.18681 23.0617C5.45693 20.4445 5.36559 16.1098 7.98279 13.3799C10.1519 11.1174 13.5009 10.6673 16.1381 12.0696L22.3477 5.59256ZM10.7716 20.3656C12.0125 21.5552 13.9828 21.5137 15.1724 20.2728C16.3621 19.032 16.3205 17.0617 15.0797 15.872C13.8388 14.6824 11.8685 14.7239 10.6789 15.9648C9.48927 17.2056 9.53079 19.1759 10.7716 20.3656Z" fill="#C4B9AE" />
    <path fillRule="evenodd" clipRule="evenodd" d="M18.8342 14.6544L21.6355 11.7325L23.4329 13.4557L26.8413 9.90062L22.3477 5.59256L16.1381 12.0696C13.5009 10.6673 10.1519 11.1174 7.98279 13.3799C5.36559 16.1098 5.45693 20.4445 8.18681 23.0617C10.9167 25.6789 15.2513 25.5875 17.8685 22.8577C20.0377 20.5951 20.3463 17.2302 18.8342 14.6544ZM22.3775 7.00646L16.3365 13.3076L15.6686 12.9525C13.416 11.7548 10.556 12.1409 8.70464 14.072C6.46965 16.4032 6.54765 20.1048 8.87886 22.3398C11.2101 24.5748 14.9117 24.4968 17.1467 22.1656C18.9981 20.2345 19.2634 17.3608 17.9718 15.1606L17.5889 14.5083L21.6057 10.3186L23.4032 12.0418L25.4274 9.93041L22.3775 7.00646ZM15.8943 20.9649C14.3224 22.6044 11.7191 22.6592 10.0796 21.0874C8.44008 19.5156 8.38521 16.9122 9.95706 15.2727C11.5289 13.6332 14.1322 13.5783 15.7718 15.1502C17.4113 16.722 17.4661 19.3254 15.8943 20.9649ZM15.1724 20.2728C13.9828 21.5137 12.0125 21.5552 10.7716 20.3656C9.53079 19.1759 9.48927 17.2056 10.6789 15.9648C11.8685 14.7239 13.8388 14.6824 15.0797 15.872C16.3205 17.0617 16.3621 19.032 15.1724 20.2728Z" fill="#A4998F" />
    <defs>
      <linearGradient id="paint0_linear_1255_45554" x1="-0.433294" y1="1.5395" x2="23.9928" y2="24.3842" gradientUnits="userSpaceOnUse">
        <stop stopColor="#454545" />
        <stop offset="1" stopColor="#454545" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>,
};

export function PortraitWrapper2(props) {
  const { agent, className, onClick, preset, inSquad } = props;
  const { name, role, tier, level } = agent;
  const url = iconurl(name);
  let body = null;
  let background = null;
  if (url) {
    body = <img draggable="false" alt={name} src={url} className={className} onDragStart={(e) => e.preventDefault()} />;
  }
  if (!isNaN(url)) {
    background = <div className={'portrait-wrapper2-portrait-background portrait-wrapper2-portrait-background-' + role} />
    body = <PortraitView role={role} idx={url} preset={preset} className={className} noframe={true} />;
  }
  let label = null;
  let attrs = {
    className: (className ? className + ' portrait-wrapper2' : 'portrait-wrapper2') + (onClick ? ' clickable' : ''),
    onClick,
    'data-clickable': onClick ? 'true' : undefined,
  };
  let deathBanner = null;
  let squadBanner = null;
  if (inSquad) {
    squadBanner = <div className="portrait-wrapper2-squad">
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 42 42" fill="none">
        <rect x="21" y="-0.414214" width="30.2843" height="30.2843" rx="5" transform="rotate(45 21 -0.414214)" fill="#2A1E1B" stroke="#FBF5CE" strokeWidth="2" />
        <path fillRule="evenodd" clipRule="evenodd" d="M30.9573 26.6716C30.9526 26.6736 30.9503 26.6741 30.9503 26.6741C30.9503 26.6741 26.8808 24.0856 26.5502 23.8328C26.5502 23.8328 26.6204 23.2151 26.702 22.7446C26.702 22.7446 26.7878 21.9123 27.2082 21.4428L27.2096 21.4482L27.2092 21.4428C27.2092 21.4428 27.5815 20.9704 28.9279 20.4985H28.926C30.0973 20.2442 29.9724 19.5184 29.9724 19.5184C29.7798 19.2275 29.5252 18.5492 29.5252 18.5492C29.1661 17.5814 29.3367 16.677 29.3367 16.677C29.6124 15.3409 30.7982 15.2755 30.9494 15.2726C30.9494 15.2726 30.9521 15.2725 30.9573 15.2725C30.9626 15.2725 30.9653 15.2726 30.9653 15.2726C31.1164 15.2755 32.3022 15.3409 32.5779 16.677C32.5779 16.677 32.7485 17.5814 32.3895 18.5492C32.3895 18.5492 32.1349 19.2275 31.9422 19.5184C31.9422 19.5184 31.8174 20.2442 32.9887 20.4985H32.9867C34.3331 20.9704 34.7054 21.4428 34.7054 21.4428L34.705 21.4482L34.7065 21.4428C35.1269 21.9123 35.2126 22.7446 35.2126 22.7446C35.2943 23.2151 35.3645 23.8328 35.3645 23.8328C35.0338 24.0856 30.9644 26.6741 30.9644 26.6741C30.9644 26.6741 30.962 26.6736 30.9573 26.6716ZM11.0429 26.6716C11.0382 26.6736 11.0358 26.6741 11.0358 26.6741C11.0358 26.6741 6.96638 24.0856 6.63574 23.8328C6.63574 23.8328 6.70592 23.2151 6.78759 22.7446C6.78759 22.7446 6.87331 21.9123 7.29375 21.4428L7.29516 21.4482L7.29477 21.4428C7.29477 21.4428 7.6671 20.9704 9.0135 20.4985H9.01155C10.1828 20.2442 10.058 19.5184 10.058 19.5184C9.86539 19.2275 9.61078 18.5492 9.61078 18.5492C9.2517 17.5814 9.4223 16.677 9.4223 16.677C9.698 15.3409 10.8838 15.2755 11.035 15.2726C11.035 15.2726 11.0377 15.2725 11.0429 15.2725C11.0481 15.2725 11.0508 15.2726 11.0508 15.2726C11.202 15.2755 12.3878 15.3409 12.6635 16.677C12.6635 16.677 12.834 17.5814 12.475 18.5492C12.475 18.5492 12.2204 19.2275 12.0278 19.5184C12.0278 19.5184 11.9029 20.2442 13.0742 20.4985H13.0722C14.4187 20.9704 14.791 21.4428 14.791 21.4428L14.7906 21.4482L14.7921 21.4428C15.2124 21.9123 15.2982 22.7446 15.2982 22.7446C15.3798 23.2151 15.4501 23.8328 15.4501 23.8328C15.1194 24.0856 11.05 26.6741 11.05 26.6741C11.05 26.6741 11.0476 26.6736 11.0429 26.6716ZM21.0001 16.8377C20.9954 16.8396 20.993 16.8406 20.993 16.8406C20.993 16.8406 16.9236 14.2519 16.5929 13.9987C16.5929 13.9987 16.6632 13.3815 16.7448 12.9109C16.7448 12.9109 16.8306 12.0783 17.2509 11.6089L17.2524 11.6144L17.252 11.6092C17.252 11.6092 17.6243 11.1368 18.9707 10.6649L18.9688 10.6648C20.1401 10.4103 20.0152 9.68453 20.0152 9.68453C19.8226 9.3936 19.568 8.71545 19.568 8.71545C19.2089 7.74735 19.3795 6.84316 19.3795 6.84316C19.6552 5.50705 20.841 5.44167 20.9922 5.43878C20.9922 5.43878 20.9949 5.43869 21.0001 5.43873C21.0053 5.43869 21.008 5.43878 21.008 5.43878C21.1592 5.44167 22.345 5.50705 22.6207 6.84316C22.6207 6.84316 22.7913 7.74735 22.4322 8.71545C22.4322 8.71545 22.1776 9.3936 21.985 9.68453C21.985 9.68453 21.8602 10.4103 23.0314 10.6648L23.0295 10.6649C24.3759 11.1368 24.7482 11.6092 24.7482 11.6092L24.7478 11.6144L24.7492 11.6089C25.1696 12.0783 25.2554 12.9109 25.2554 12.9109C25.337 13.3815 25.4073 13.9987 25.4073 13.9987C25.0766 14.2519 21.0072 16.8406 21.0072 16.8406C21.0072 16.8406 21.0048 16.8396 21.0001 16.8377ZM21.0001 36.5586C20.9954 36.5605 20.993 36.5615 20.993 36.5615C20.993 36.5615 16.9236 33.9725 16.5929 33.7197C16.5929 33.7197 16.6632 33.102 16.7448 32.6316C16.7448 32.6316 16.8306 31.7992 17.2509 31.3297L17.2524 31.3351L17.252 31.3297C17.252 31.3297 17.6243 30.8573 18.9707 30.3859L18.9688 30.3854C20.1401 30.1311 20.0152 29.4054 20.0152 29.4054C19.8226 29.1144 19.568 28.4361 19.568 28.4361C19.2089 27.4683 19.3795 26.564 19.3795 26.564C19.6552 25.228 20.841 25.1625 20.9922 25.1595C20.9922 25.1595 20.9949 25.1595 21.0001 25.1595C21.0053 25.1595 21.008 25.1595 21.008 25.1595C21.1592 25.1625 22.345 25.228 22.6207 26.564C22.6207 26.564 22.7913 27.4683 22.4322 28.4361C22.4322 28.4361 22.1776 29.1144 21.985 29.4054C21.985 29.4054 21.8602 30.1311 23.0314 30.3854L23.0295 30.3859C24.3759 30.8573 24.7482 31.3297 24.7482 31.3297L24.7478 31.3351L24.7492 31.3297C25.1696 31.7992 25.2554 32.6316 25.2554 32.6316C25.337 33.102 25.4073 33.7197 25.4073 33.7197C25.0766 33.9725 21.0072 36.5615 21.0072 36.5615C21.0072 36.5615 21.0048 36.5605 21.0001 36.5586ZM19.5677 21.0917L11.7276 12.4006L12.345 11.7807L21.0001 19.6534L29.6552 11.7807L30.2726 12.4006L22.4325 21.0917L30.2726 29.7829L29.6552 30.4025L21.0001 22.53L12.345 30.4025L11.7276 29.7829L19.5677 21.0917Z" fill="#FBF5CE" />
      </svg>
    </div>;
  }
  return <div className="portrait-wrapper2-outer">
    <div {...attrs}>
      <div className="portrait-wrapper2-backgrounds">
        <div className="portrait-wrapper2-backgrounds-gray" />
        <div className="portrait-wrapper2-backgrounds-brown" />
        <div className="portrait-wrapper2-backgrounds-yellow" />
      </div>
      <div className="portrait-wrapper2-portrait">
        {background}
        {body}
        <div className="portrait-wrapper2-portrait-shadow" />
        {roleIconTags[role]}
        <TierBadge2 tier={tier} isFormal={true} />
        <span className="portrait-wrapper2-level">Lv. {level.cur}</span>
      </div>
      {label}
    </div>
    {squadBanner}
  </div>;

}

export function PortraitView(props) {
  const { preset, noframe, idx, role } = props;
  let cur = props.cur;
  if (!cur) {
    cur = generatePortrait(role, idx);
  }

  const layers = [];
  for (const [cat, item] of Object.entries(cur)) {
    if (item === null) {
      continue;
    }
    layers.push(<img alt="" draggable="false" className='portrait-part' key={cat} src={item} style={{ transform: ((preset === '') ? DEFAULT_PRESET : preset) }} />);
  }

  let cls = noframe ? 'portrait-noframe' : 'portrait-frame';
  if (props.className) {
    cls += ' ' + props.className;
  }

  return <div className={cls}>
    {layers}
  </div>;
}

const roles = [
  'pointman',
  'vanguard',
  'medic',
  'breacher',
  'sharpshooter',
]

export class PortraitsView extends Component {
  constructor(props) {
    super(props);

    const rng = new Rng();
    const role = rng.choice(roles);
    const cur = generatePortrait(role, rng.integer(0, 10000));

    this.state = {
      role,
      rng,
      cur,
      preset: DEFAULT_PRESET,
    };
  }

  customButtons() {
    const { role, cur, rng } = this.state;
    const layers = portraitResources[role]
    const buttons = [];

    buttons.push(
      <div>
        <span>role</span>
        {
          roles.map(e => {
            return <button onClick={() => {
              const cur = generatePortrait(e, rng.integer(0, 10000));
              this.setState({ role: e, cur });
            }}>
              {e}
            </button>
          })
        }
      </div>
    );

    for (const key in layers) {
      buttons.push(
        <div>
          <span>{key}</span>
          {
            layers[key].map(e => {
              return <button onClick={() => {
                let next = cur;
                next[key] = e;
                this.setState({ cur: next })
              }
              }>
                {e.replace('/portrait/', '')}
              </button>;
            })
          }
        </div>
      );
    }
    return buttons;
  }

  render() {
    const { cur, rng, role } = this.state;
    const url = iconurl('Janton');

    // i18n ignore 45
    return <div>
      <div>
        <span>프리셋: </span>
        <input className="portraitsview-preset-input" value={this.state.preset} onChange={(e) => this.setState({ preset: e.target.value })} />
        <div>{role}</div>
      </div>
      <div className='portraitsview-preset-row'>
        <PortraitView cur={cur} preset={this.state.preset} />
        <img alt='Anton Chigurh' src={url} className='portrait-frame' onDragStart={(e) => e.preventDefault()} />
      </div>
      <div className='portraitsview-preset-row'>
        <PortraitView cur={cur} className='portrait-frame-small0' preset={this.state.preset} />
        <img alt='Anton Chigurh' src={url} className='portrait-frame portrait-frame-small0' onDragStart={(e) => e.preventDefault()} />
      </div>
      <div className='portraitsview-preset-row'>
        <PortraitView cur={cur} className='portrait-frame-small1' preset={this.state.preset} />
        <img alt='Anton Chigurh' src={url} className='portrait-frame portrait-frame-small1' onDragStart={(e) => e.preventDefault()} />
      </div>
      <div className='portraitsview-preset-row'>
        <PortraitView cur={cur} className='portrait-frame-small2' preset={this.state.preset} />
        <img alt='Anton Chigurh' src={url} className='portrait-frame portrait-frame-small2' onDragStart={(e) => e.preventDefault()} />
      </div>
      <div className='portraitsview-preset-row'>
        <PortraitView cur={cur} className='portrait-frame-small3' preset={this.state.preset} />
        <img alt='Anton Chigurh' src={url} className='portrait-frame portrait-frame-small3' onDragStart={(e) => e.preventDefault()} />
      </div>
      <div className='portraitsview-preset-row'>
        <PortraitView cur={cur} className='portrait-frame-small4' preset={this.state.preset} />
        <img alt='Anton Chigurh' src={url} className='portrait-frame portrait-frame-small4' onDragStart={(e) => e.preventDefault()} />
      </div>
      <div className='portraitsview-preset-row'>
        <PortraitView cur={cur} className='portrait-frame-small5' preset={this.state.preset} />
        <img alt='Anton Chigurh' src={url} className='portrait-frame portrait-frame-small5' onDragStart={(e) => e.preventDefault()} />
      </div>
      <button onClick={() => {
        const role = rng.choice(roles);
        const cur = generatePortrait(role, rng.integer(0, 10000));
        this.setState({ role, cur });
      }}>Random</button>
      {
        this.customButtons()
      }
    </div>;
  }
}
